import type { LegalSection } from './legal-section';

export const TERMS_BUSINESS: readonly LegalSection[] = [
  {
    title: '1. Objeto y aceptación',
    body: `Estos Términos regulan la relación mercantil entre La divina comedia sa y el Collector. La aceptación mediante el registro es condición indispensable para el acceso al servicio.`,
  },
  {
    title: '2. Condición de profesional independiente',
    body: `La relación es estrictamente mercantil y NO laboral. El Collector actúa como profesional independiente, asumiendo su propio riesgo y ventura, y es responsable único de sus obligaciones fiscales, mercantiles y de seguridad social en su jurisdicción.

CLÁUSULA DE PAGO EXCLUSIVO EN USDC: Debook liquida todas las compensaciones exclusivamente en USDC (stablecoin vinculada al dólar). El Collector acepta expresamente este medio de pago y declara poseer una wallet propia bajo su control. Debook NO presta servicios de custodia ni es un CASP. Los errores en el suministro de la dirección de wallet que resulten en pérdida de fondos son responsabilidad exclusiva del Collector.`,
  },
];
